import React from 'react';
import { useEffect } from 'react';
import { FormContainer, setInputProps } from '../../components/common/forms/Form';
import { bookSchema } from '../../components/common/forms/constraints/ValidatonSchemas';
import './book.scss';
import axios from 'axios';
import { SperantService } from '../../components/common/Http/api';
import Swal from 'sweetalert2';
import { ComplaintMailPDF } from './ComplaintMail';
import { dataprojects } from './dataprojects';
import { MailService } from '../../components/common/Http/MailService';
import { useDispatch } from 'react-redux';
import { setActiveModal } from '../../data/modal';
import { emailMaster, mailClient } from './mail';

// export const mookInitialValues = {
// 	project: 'Avantte',
// 	fname: 'Prueba',
// 	lname: 'Prueba',
// 	mlname: 'Prueba',
// 	email: 'mataqque.100@gmail.com',
// 	telephone: '123456789',
// 	idType: 'DNI',
// 	idNumber: '12345678',
// 	region: 'Lima',
// 	province: 'Lima',
// 	district: 'Miraflores',
// 	address: 'Av. Principal',
// 	typeOfGood: 'Producto',
// 	orderNumber: '123',
// 	amount: '100',
// 	goodDescription: 'description prueba',
// 	complaintType: 'Reclamo',
// 	complaintDetail: '123',
// 	consumerPetition: '123',
// 	sellerAction: 'acciones',
// 	terms: true,
// };
export const BookComplaints = () => {
	const dispatch = useDispatch();

	const initialValues = {
		project: '',
		fname: '',
		lname: '',
		mlname: '',
		email: '',
		telephone: '',
		idType: '',
		idNumber: '',
		region: '',
		province: '',
		district: '',
		address: '',
		typeOfGood: '',
		orderNumber: '',
		amount: '',
		goodDescription: '',
		complaintType: '',
		complaintDetail: '',
		consumerPetition: '',
		sellerAction: '',
		terms: false,
	};
	const submitForm = async (values, { setSubmitting, resetForm }) => {
		try {
			const { data } = await axios.post('https://fbleads.formulaperu.com/api/webhooks/e2bbdaa5-8220-48b8-b207-1e65211f6965', {
				book_number_target: '[BOOK_NUMBER]',
				html: ComplaintMailPDF(values, dataprojects[values.project]),
				book_number_discriminator: 'biabo',
			});

			if (!data.success) throw new Error(data.message);

			const book = {
				bookNumber: data.bookNumber,
				pdfBase64: `data:application/pdf;base64,${data.pdfBase64}`,
			};

			const b64toBlob = base64 => fetch(base64).then(res => res.blob());
			const file = await b64toBlob(book.pdfBase64);

			await new MailService().from('Biabo inmobiliaria <contacto@biabo.pe>').to(values.email).subject(`Constancia de reclamo N° ${book.bookNumber} ${values.project}`).html(mailClient).send();

			await new MailService()
				.from('Biabo inmobiliaria <contacto@biabo.pe>')
				.to('contacto@biabo.pe')
				.to('garden@biabo.pe')
				.subject(`Libro de Reclamaciones Virtual`)
				.html(emailMaster)
				.attachment(`Reclamo_N${book.bookNumber}.pdf`, file)
				.send();

			const date = new Date().toLocaleString('es-PE', { timeZone: 'America/Lima' });
			axios
				.post(
					'https://n8n.formulaperu.com/webhook/google-sheets',
					{
						spreadsheetId: '1zTBhRccGsbyRSccOY-RA9MlelZ-ZLS1WHkFgo77VCiA',
						sheetId: '0',
						append: [
							{
								Fecha: date,
								Proyecto: values.project,
								'Número de ficha': book.bookNumber,
								Nombres: `${values.fname}`,
								'Apellido paterno': values.lname,
								'Apellido materno': values.mlname,
								Correo: values.email,
								Teléfono: values.telephone,
								'Tipo Doc': values.idType,
								'Nro. Documento': values.idNumber,
								Departamento: values.region,
								Provincia: values.province,
								Distrito: values.district,
								Dirección: values.address,
								'Tipo bien contratado': values.typeOfGood,
								'Nro. de pedido': values.orderNumber,
								Monto: values.amount,
								'Descripción del bien contratado': values.goodDescription,
								'Tipo de reclamo': values.complaintType,
								'Descipción de lo contratado': values.consumerPetition,
								'Pedido de consumidor': values.consumerPetition,
								'Descripción de reclamo': values.complaintDetail,
								'Acciones del vendedor': values.sellerAction,
							},
						],
					},
					{
						headers: {
							Authorization: 'Basic' + Buffer.from('biabo:s89d78s9g7d98g7sa98f7s8f8s').toString('base64'),
						},
					}
				)
				.then(() => {
					Swal.fire({
						icon: 'success',
						title: 'Reclamo enviado con éxito',
						text: `Su número de reclamo es: ${book.bookNumber}. Se ha enviado una constancia a su correo electrónico.`,
						confirmButtonText: 'Aceptar',
					});
					resetForm();
				})
				.catch(error => {
					Swal.fire({
						icon: 'error',
						title: 'Error al registrar el reclamo',
						text: `Ha ocurrido un error al registrar su reclamo. Por favor, intente nuevamente más tarde.`,
						confirmButtonText: 'Aceptar',
					});
					console.log('Error al registrar en Google Sheets:', error);
				});
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		document.querySelector('html').scrollTop = 0;
		document.querySelector('.Navbar').classList.add('inactiveDesktop');
	}, []);
	return (
		<main className='libro-de-reclamaciones '>
			<div className='container'>
				<h1 className='title'>Libro de Reclamaciones</h1>

				<FormContainer initialValues={initialValues} onSubmit={submitForm} validationSchema={bookSchema}>
					{form => {
						const { handleSubmit, isSubmitting } = form;
						console.log(form);
						return (
							<form className='formulario' onSubmit={handleSubmit}>
								<div className='flex-column'>
									<select {...setInputProps('project', 'select mb-8 select-project', form)}>
										<option value=''>Proyecto</option>
										<option value='Avantte'>Avantte</option>
										<option value='Garden'>Garden</option>
										<option value='Skyna'>Skyna</option>
									</select>
								</div>
								<p className='text-center mb-8 parrafo'>
									Conforme a lo establecido en el Código de Protección y Defensa del Consumidor, esta institución cuenta con un Libro de Reclamaciones a su disposición.
								</p>
								<div className='grid gap-4'>
									<div className='grid grid-cols-3 gap-4'>
										<div className='flex-column'>
											<input type='text' {...setInputProps('fname', 'input ', form)} placeholder='Nombre*'></input>
										</div>
										<div className='flex-column'>
											<input type='text' {...setInputProps('lname', 'input ', form)} placeholder='Apellido parterno*'></input>
										</div>
										<div className='flex-column'>
											<input type='text' {...setInputProps('mlname', 'input ', form)} placeholder='Apellido materno*'></input>
										</div>
									</div>
									<div className='grid grid-cols-4 gap-4'>
										<div className='flex-column'>
											<input type='text' {...setInputProps('email', 'input ', form)} placeholder='Correo Electrónico*'></input>
										</div>
										<div className='flex-column'>
											<input type='text' {...setInputProps('telephone', 'input ', form)} placeholder='Telefono*'></input>
										</div>
										<select {...setInputProps('idType', 'select', form)}>
											<option value=''>Tipo de documento</option>
											<option value='DNI'>DNI</option>
											<option value='RUC'>RUC</option>
											<option value='Carnet de Extranjeria'>Carnet de Extranjeria</option>
										</select>
										<div className='flex-column'>
											<input type='text' {...setInputProps('idNumber', 'input ', form)} placeholder='N° de documento'></input>
										</div>
									</div>
									<div className='grid grid-cols-3 gap-4'>
										<div className='flex-column'>
											<input type='text' {...setInputProps('region', 'input ', form)} placeholder='Departamento'></input>
										</div>
										<div className='flex-column'>
											<input type='text' {...setInputProps('province', 'input ', form)} placeholder='Provincia'></input>
										</div>
										<div className='flex-column'>
											<input type='text' {...setInputProps('district', 'input ', form)} placeholder='Distrito'></input>
										</div>
									</div>
									<div className='flex-column w-full'>
										<input type='text' {...setInputProps('address', 'input ', form)} placeholder='Dirección'></input>
									</div>
								</div>
								<span className='sub-title'>IDENTIFICACIÓN DEL BIEN CONTRATADO</span>
								<div className='grid gap-4'>
									<div className='grid grid-cols-3 gap-4'>
										<select {...setInputProps('typeOfGood', 'select', form)}>
											<option value=''>Tipo de Bien Contratado*</option>
											<option value='Producto'>Producto</option>
											<option value='Servicio'>Servicio</option>
										</select>
										<div className='flex-column'>
											<input type='text' {...setInputProps('orderNumber', 'input ', form)} placeholder='N° de pedido*'></input>
										</div>
										<div className='flex-column'>
											<input type='text' {...setInputProps('amount', 'input ', form)} placeholder='Monto*'></input>
										</div>
									</div>
									<div className='flex-column w-full'>
										<textarea type='text' {...setInputProps('goodDescription', 'input ', form)} placeholder='Descripción*'></textarea>
									</div>
								</div>
								<span className='sub-title'>DETALLE DE LA RECLAMACIÓN</span>
								<div className='grid gap-4'>
									<div className='grid grid-cols-2 gap-4'>
										<select {...setInputProps('complaintType', 'select', form)}>
											<option value=''>Tipo de reclamo*</option>
											<option value='Reclamo'>Reclamo</option>
											<option value='Queja'>Queja</option>
										</select>
										<div className='flex-column'>
											<input type='text' {...setInputProps('consumerPetition', 'input ', form)} placeholder='Pedido del Consumidor*'></input>
										</div>
									</div>
									<div className='flex-column w-full'>
										<textarea type='text' {...setInputProps('complaintDetail', 'input ', form)} placeholder='Descripción*'></textarea>
									</div>
								</div>
								<span className='sub-title'>ACCIONES ADOPTADAS POR EL VENDEDOR</span>
								<div className='flex-column w-full'>
									<textarea type='text' {...setInputProps('sellerAction', 'input ', form)} placeholder='Descripción*'></textarea>
								</div>
								{/* <div className='flex gap-4 my-4 items-center'>
									<div className='relative flex items-center justify-center h-max group undefined'>
										<input
											type='checkbox'
											id='terms'
											{...setInputProps('terms', 'peer absolute opacity-0 pointer-events-none peer-checked:[.icon-check]:bg-white ', form)}
											value='false'
										/>
										<label
											className='flex w-5 h-5 min-w-5 mobile:w-5 mobile:h-5 mobile:min-w-5 border bg-transparent peer-checked peer-checked:bg-primary  border-solid border-primary items-center justify-center cursor-pointer undefined [.--invalid]:border-danger'
											for='terms'
										></label>
										<div className='mask mask-center icon-check-form w-3/6 h-4/6 bg-transparent peer-checked:bg-white absolute top-0 left-0 bottom-0 right-0 m-auto pointer-events-none '></div>
									</div>
									<span className='text-gray-70  mr-auto text-1/2 leading-[1.5]'>
										Acepto las{' '}
										<span
											onClick={() => {
												dispatch(setActiveModal(true));
											}}
											className='underline text-gray-80 text-1/2 font-poppins_light'
										>
											políticas de privacidad
										</span>
									</span>
								</div> */}
								<button type='submit' className='btn-submit' disabled={isSubmitting}>
									{isSubmitting ? 'Enviando...' : 'Enviar'}
								</button>
							</form>
						);
					}}
				</FormContainer>
			</div>
		</main>
	);
};
